import bigDecimal from 'js-big-decimal';

import { EFaktura } from '../../../generated-types';

export const getCombinedEFakturaAmount = (eFakturas: EFaktura[]) => {
    return eFakturas
        .map((eFakura) => Math.max(eFakura.amount, eFakura.minimumAmount ?? 0))
        .reduce((previousValue, currentValue) => parseFloat(bigDecimal.add(previousValue, currentValue)), 0);
};
